import React, {useEffect, useState} from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'

import { localize } from 'helpers/translator'
import { MainButton, CancelButton } from 'components/button'
import FolderItem from './folder_item'

import styles from './add_lesson_to_folder_with_navigation.scss'
import BackIcon from 'assets/components/add_to_folder/back.svg'

const AddLessonToFolderWithNavigation = props => {
	const [selectedFolderId, setSelectedFolderId] = useState('0')

	useEffect(() => {
		props.handleFolderIdUpdated(selectedFolderId)
	}, [selectedFolderId])

	const getFolders = () => props.folders.map(folder =>
		<li
			key={folder.id}
		>
			<FolderItem
				id={folder.id}
				name={folder.name}
				handleSelect={setSelectedFolderId}
			/>
		</li>
	)

	const addLesson = () => {
		props.handleAddLesson(selectedFolderId)
	}

	const handleBackSelected = () => {
		setSelectedFolderId(props.parentFolderId)
	}

	const renderParentFolder = () => {
		if (props.parentFolderId) {
			return (
				<div styleName='current-folder-wrapper' onClick={handleBackSelected}>
					<img styleName='current-folder-back-icon' src={BackIcon} alt='Back' />
					<span styleName='current-folder-clickable-text'>{props.currentFolderName}</span>
				</div>)
		} else {
			return (
				<div styleName='current-folder-wrapper'>
					<span>{props.currentFolderName}</span>
				</div>)
		}
	}

	return (
		<div styleName='wrapper'>
			<h4 styleName='title'>{props.title}</h4>
			{renderParentFolder()}
			<ul styleName='results-list'>
				{getFolders()}
			</ul>
			<div styleName='btn-bar'>
				<div styleName='btn-bar-container'>
					<CancelButton type='button' onClick={props.handleCancelSelected}>
						{localize('global_cancel')}
					</CancelButton>
				</div>
				<div styleName='btn-bar-container'>
					<MainButton onClick={addLesson}>
						{localize('my_library_add_lessons_to_pl_modal')}
					</MainButton>
				</div>
			</div>
		</div>
	)
}

AddLessonToFolderWithNavigation.propTypes = {
	title: PropTypes.string.isRequired,
	handleCancelSelected: PropTypes.func.isRequired,
	folders: PropTypes.array.isRequired,
	handleAddLesson: PropTypes.func.isRequired,
	handleFolderIdUpdated: PropTypes.func.isRequired,
	parentFolderId: PropTypes.string,
	currentFolderName: PropTypes.string.isRequired,
}

export default CSSModules(AddLessonToFolderWithNavigation, styles, { allowMultiple: true })
